export default __webpack_public_path__ + "c2b7b99a7f54b228ab2625458749078c.jpg";